import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface LandscapingProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Landscaping: React.FC<LandscapingProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [landscaping, set_landscaping] = useBudgetFixFlipField<number>(
        propertyGuid,
        (b) => (b.values?.['Final Structure']?.['Landscaping']?.[1] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Final Structure': { ...b.values?.['Final Structure'], 'Landscaping': [b.values?.['Final Structure']?.['Landscaping']?.[0] ?? '', v] as [string, number] } } })
    );
    const label = 'Landscaping';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(landscaping)}
                />
            ) : (
                <MoneyBox
                    id={'landscaping'}
                    allowNegative={false}
                    value={landscaping}
                    onChange={(value) => set_landscaping(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
